import {ChangeDetectionStrategy, Component, EventEmitter, input, Output, output} from "@angular/core";
import {ArkivFilnodeModell, GruppeId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {ArkivVelgNodeKomponent} from "../../../arkiv/komponenter/arkiv-velg-node/arkiv-velg-node";
import {FormControl} from "@angular/forms";
import {filterNil} from "@ngneat/elf";

const debug = initDebugger('SakVelgArkivdokumentKomponent');

/**
 * Presenterer arkiv-tre der bruker kan drille ned til dokument som skal inkluderes som saksdokument i sak.
 * For bruk i ajs
 */
//@todo slettes
@Component({
    selector: 'sak-velg-arkivdokument',
    templateUrl: 'sak-velg-arkivdokument.html',
    imports: [
        ArkivVelgNodeKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SakVelgArkivdokumentKomponent {
    static ajsSelector = 'sakVelgArkivdokument';

    @Output() vedFilValgt = new EventEmitter<ArkivFilnodeModell>(); //output() fungerer ikke med ajs

    gruppeId = input.required<GruppeId>();

    kunDokumenter = ArkivVelgNodeKomponent.kunDokumenter;
    dokument = new FormControl<ArkivFilnodeModell|null>(null);

    constructor() {
        this.dokument.valueChanges
          .pipe(takeUntilDestroyed(), filterNil())
          .subscribe(dokument => this.vedFilValgt.emit(dokument));
    }
}
